export const RADIAL_BANDS = [
  { bandIndex: 0, innerRadius: 0, outerRadius: 8, label: "Silly" },
  { bandIndex: 1, innerRadius: 8, outerRadius: 16, label: "Very Close" },
  { bandIndex: 2, innerRadius: 16, outerRadius: 24, label: "Inner Ring" },
  { bandIndex: 3, innerRadius: 24, outerRadius: 32, label: "Mid Ring" },
  { bandIndex: 4, innerRadius: 32, outerRadius: 40, label: "Deep" },
  { bandIndex: 5, innerRadius: 40, outerRadius: 48, label: "Boundary" },
];
